"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keys = void 0;
exports.keys = (value) => Object.keys(value);
//# sourceMappingURL=keys.js.map